import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=2cffb48c&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Home.vue?vue&type=style&index=1&id=2cffb48c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cffb48c",
  null
  
)

export default component.exports